"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataState = void 0;
const React = __importStar(require("react"));
const StickinessPageHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/StickinessPageHighchartsOptionsProvider");
const antd_1 = require("antd");
const StickinessPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/StickinessPopover");
const StickinessExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/StickinessExportHighchartsButton");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const react_router_dom_1 = require("react-router-dom");
const StickinessPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageDataProvider");
const StickinessPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageModelProvider");
const StickinessFormComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/form/StickinessFormComponent");
const StickinessChartSettingsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/highchartsSettings/StickinessChartSettingsComponent");
const StickinessHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/StickinessHighchartsComponent");
const DataState = () => {
    return React.createElement(React.Fragment, null,
        React.createElement(StickinessPageHighchartsOptionsProvider_1.StickinessPageHighchartsOptionsProvider, null,
            React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
                    React.createElement(React.Fragment, null, "Stickiness"),
                    React.createElement(StickinessPopover_1.StickinessPopover, null)), extra: React.createElement(antd_1.Space, null,
                    React.createElement(StickinessExportHighchartsButton_1.StickinessExportHighchartsButton, null)) }),
            React.createElement(PageContent_1.default, null,
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(StickinessChartSettingsComponent_1.StickinessChartSettingsComponent, null),
                    React.createElement(StickinessHighchartsComponent_1.StickinessHighchartsComponent, null)),
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(antd_1.Row, null,
                        React.createElement(antd_1.Col, { span: 24 },
                            React.createElement(StickinessFormComponent_1.StickinessFormComponent, null)))))),
        process.env.NODE_ENV === "development" ? React.createElement(DebugView, null) : null);
};
exports.DataState = DataState;
const DebugView = () => {
    const stickinessPageDataContext = (0, StickinessPageDataProvider_1.useStickinessPageDataContext)();
    const stickinessPageModelContext = (0, StickinessPageModelProvider_1.useStickinessPageModelContext)();
    const location = (0, react_router_dom_1.useLocation)();
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(antd_1.Row, { gutter: [16, 16] },
                    React.createElement(antd_1.Col, { span: 24 },
                        "location:",
                        React.createElement("br", null),
                        React.createElement("span", { style: { fontSize: "10px", maxHeight: 180, wordBreak: "break-all" } }, decodeURI(location.search))),
                    React.createElement(antd_1.Col, { span: 8 },
                        "pageModelFormState:",
                        React.createElement("br", null),
                        React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(stickinessPageModelContext.pageModelFormState, null, 4))),
                    React.createElement(antd_1.Col, { span: 8 },
                        "dataURLState:",
                        React.createElement("br", null),
                        React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(stickinessPageDataContext.urlState, null, 4))),
                    React.createElement(antd_1.Col, { span: 8 },
                        "dataState:",
                        React.createElement("br", null),
                        React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(stickinessPageDataContext.state, null, 4)))),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("br", null))));
};
